type CardProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export function Card({ title, children, className, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={`bg-card border border-line rounded-lg p-[16px_18px] ${className ?? ""}`}
    >
      {title && <p className="text-[12px] text-ink-2 font-semibold mb-3">{title}</p>}
      {children}
    </div>
  );
}
